module.exports = __webpack_public_path__ + "img/mzn.c25cb8f7.jpg";